import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-start">
        <Link to={isAdmin ? '/admin' : '/dashboard'} className="navbar-brand" title="רשות הצעירים של ירושלים">
          <img src="/logo_rashut.png" alt="רשות הצעירים של ירושלים" className="navbar-logo" />
          <span className="navbar-title">משוב והתפתחות</span>
        </Link>
        {user && (
          <span className="navbar-who" title="המשתמש/ת המחובר/ת">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></svg>
            <span>מחובר/ת: <strong>{user.full_name}</strong></span>
          </span>
        )}
      </div>
      {user && (
        <div className="navbar-user">
          {isAdmin && (
            <>
              <Link to="/admin" style={{ textDecoration: 'none', color: 'var(--gray-700)', fontSize: '14px' }}>דף הבית</Link>
              <Link to="/admin/dashboard" style={{ textDecoration: 'none', color: 'var(--gray-700)', fontSize: '14px' }}>לוח בקרה</Link>
              <Link to="/admin/users" style={{ textDecoration: 'none', color: 'var(--gray-700)', fontSize: '14px' }}>עובדים</Link>
              <Link to="/admin/cycles" style={{ textDecoration: 'none', color: 'var(--gray-700)', fontSize: '14px' }}>תהליכים</Link>
            </>
          )}
          <button onClick={handleLogout}>התנתק</button>
        </div>
      )}
    </nav>
  );
}
